import { httpwmsapi } from 'src/services';
import queryString from 'query-string';

// Action Types
export const Types = {
  RECEIVING_SCHEDULE_LOADING: 'receiving_nfe/loading',

  RECEIVING_SCHEDULE_SET_DATA: 'receiving_schedule/set/schedule/data',
  RECEIVING_SCHEDULES_SET_DATA: 'receivings_schedule/set/schedule/data',
  RECEIVING_SCHEDULES_SET_PAGING: 'receivings_schedule/set/schedule/paging',
  RECEIVING_SCHEDULES_FILTERS_CHIP: 'receivings_schedule/set/filter_chip',
  RECEIVING_SCHEDULES_SET_FILTER: 'receivings_schedule/set/schedule/filter',

  RECEIVING_SCHEDULE_INVOICE_SET_DATA: 'receiving_schedule_invoice/set/invoice/data',
  RECEIVING_SCHEDULE_INVOICES_SET_DATA: 'receivings_schedule_invoice/set/invoice/data',
  RECEIVING_SCHEDULE_INVOICES_SET_PAGING: 'receivings_schedule_invoice/set/invoice/paging',
  RECEIVING_SCHEDULE_INVOICES_SET_FILTER: 'receivings_schedule_invoice/set/invoice/filter',

  RECEIVING_SCHEDULE_INVOICE_PRODUCT_SET_DATA: 'receiving_schedule_invoice_product/set/products/data',
  RECEIVING_SCHEDULE_INVOICE_PRODUCTS_SET_DATA: 'receivings_schedule_invoice_product/set/products/data',
  RECEIVING_SCHEDULE_INVOICE_PRODUCTS_SET_PAGING: 'receivings_schedule_invoice_product/set/products/paging',
  RECEIVING_SCHEDULE_INVOICE_PRODUCTS_SET_FILTER: 'receivings_schedule_invoice_product/set/products/filter',

  RECEIVING_SCHEDULE_UPLOAD_FILES_XML: 'receiving_schedule/upload/filesxml',
};

// Reducer
const initialState = {
  loading: false,

  receiving_schedule: {},
  receiving_schedules: [],
  receiving_schedules_paging: { limit: 25, offset: 0, total: 0, page: 0 },
  receiving_schedules_filters_chip: [],
  receiving_schedules_filters: [],

  receiving_schedule_invoice: {},
  receiving_schedule_invoices: [],
  receiving_schedule_invoices_paging: {
    limit: 25,
    offset: 0,
    total: 0,
    page: 0,
  },
  receiving_schedule_invoices_filters: [],

  receiving_schedule_invoice_product: {},
  receiving_schedule_invoice_products: [],
  receiving_schedule_invoice_products_paging: {
    limit: 25,
    offset: 0,
    total: 0,
    page: 0,
  },
  receiving_schedule_invoice_products_filters: [],

  receiving_schedule_upload_files_xml: [],
};

// Action Creators
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.RECEIVING_SCHEDULE_LOADING:
      return { ...state, loading: action.payload };

    case Types.RECEIVING_SCHEDULE_SET_DATA:
      return { ...state, receiving_schedule: action.payload };
    case Types.RECEIVING_SCHEDULES_SET_DATA:
      return { ...state, receiving_schedules: action.payload };
    case Types.RECEIVING_SCHEDULES_SET_PAGING:
      return { ...state, receiving_schedules_paging: action.payload };
    case Types.RECEIVING_SCHEDULES_FILTERS_CHIP:
      return { ...state, receiving_schedules_filters_chip: action.payload };
    case Types.RECEIVING_SCHEDULES_SET_FILTER:
      return { ...state, receiving_schedules_filters: action.payload };

    case Types.RECEIVING_SCHEDULE_INVOICE_SET_DATA:
      return { ...state, receiving_schedule_invoice: action.payload };
    case Types.RECEIVING_SCHEDULE_INVOICES_SET_DATA:
      return { ...state, receiving_schedule_invoices: action.payload };
    case Types.RECEIVING_SCHEDULE_INVOICES_SET_PAGING:
      return { ...state, receiving_schedule_invoices_paging: action.payload };
    case Types.RECEIVING_SCHEDULE_INVOICES_SET_FILTER:
      return { ...state, receiving_schedule_invoices_filters: action.payload };

    case Types.RECEIVING_SCHEDULE_INVOICE_PRODUCT_SET_DATA:
      return { ...state, receiving_schedule_invoice_product: action.payload };
    case Types.RECEIVING_SCHEDULE_INVOICE_PRODUCTS_SET_DATA:
      return { ...state, receiving_schedule_invoice_products: action.payload };
    case Types.RECEIVING_SCHEDULE_INVOICE_PRODUCTS_SET_PAGING:
      return {
        ...state,
        receiving_schedule_invoice_products_paging: action.payload,
      };
    case Types.RECEIVING_SCHEDULE_INVOICE_PRODUCTS_SET_FILTER:
      return {
        ...state,
        receiving_schedule_invoice_products_filters: action.payload,
      };

    case Types.RECEIVING_SCHEDULE_UPLOAD_FILES_XML:
      return { ...state, receiving_nfe_upload_files_xml: action.payload };
    default:
      return state;
  }
}

export const Creators = {
  receivingScheduleLoading: (value) => ({
    type: Types.RECEIVING_SCHEDULE_LOADING,
    payload: value,
  }),

  receivingScheduleSetData: (receivingSchedule) => ({
    type: Types.RECEIVING_SCHEDULE_SET_DATA,
    payload: receivingSchedule,
  }),
  receivingSchedulesSetData: (receivingSchedules) => ({
    type: Types.RECEIVING_SCHEDULES_SET_DATA,
    payload: receivingSchedules,
  }),
  receivingSchedulesSetPaging: (receivingSchedules_paging) => ({
    type: Types.RECEIVING_SCHEDULES_SET_PAGING,
    payload: receivingSchedules_paging,
  }),
  receivingSchedulesSetFiltersChip: (receivingSchedules_filters_chip) => ({
    type: Types.RECEIVING_SCHEDULES_FILTERS_CHIP,
    payload: receivingSchedules_filters_chip,
  }),
  receivingSchedulesSetFilters: (receivingSchedules_filters) => ({
    type: Types.RECEIVING_SCHEDULES_SET_FILTER,
    payload: receivingSchedules_filters,
  }),

  receivingScheduleInvoiceSetData: (receivingScheduleInvoice) => ({
    type: Types.RECEIVING_SCHEDULE_INVOICE_SET_DATA,
    payload: receivingScheduleInvoice,
  }),
  receivingScheduleInvoicesSetData: (receivingScheduleInvoices) => ({
    type: Types.RECEIVING_SCHEDULE_INVOICES_SET_DATA,
    payload: receivingScheduleInvoices,
  }),
  receivingScheduleInvoicesSetPaging: (receivingScheduleInvoices_paging) => ({
    type: Types.RECEIVING_SCHEDULE_INVOICES_SET_PAGING,
    payload: receivingScheduleInvoices_paging,
  }),
  receivingScheduleInvoicesSetFilters: (receivingScheduleInvoices_filters) => ({
    type: Types.RECEIVING_SCHEDULE_INVOICES_SET_FILTER,
    payload: receivingScheduleInvoices_filters,
  }),

  receivingScheduleInvoiceProductSetData: (receivingScheduleInvoiceProduct) => ({
    type: Types.RECEIVING_SCHEDULE_INVOICE_PRODUCT_SET_DATA,
    payload: receivingScheduleInvoiceProduct,
  }),
  receivingScheduleInvoiceProductsSetData: (receivingScheduleInvoiceProducts) => ({
    type: Types.RECEIVING_SCHEDULE_INVOICE_PRODUCTS_SET_DATA,
    payload: receivingScheduleInvoiceProducts,
  }),
  receivingScheduleInvoiceProductsSetPaging: (receivingScheduleInvoiceProducts_paging) => ({
    type: Types.RECEIVING_SCHEDULE_INVOICE_PRODUCTS_SET_PAGING,
    payload: receivingScheduleInvoiceProducts_paging,
  }),
  receivingScheduleInvoiceProductsSetFilters: (receivingScheduleInvoiceProducts_filters) => ({
    type: Types.RECEIVING_SCHEDULE_INVOICE_PRODUCTS_SET_FILTER,
    payload: receivingScheduleInvoiceProducts_filters,
  }),

  receivingScheduleUploadFilesXml: (receivingScheduleUploadFilesXml) => ({
    type: Types.RECEIVING_NFE_UPLOAD_FILES_XML,
    payload: receivingScheduleUploadFilesXml,
  }),

  getReceivingSchedules: (filters = {}) => {
    const qry = queryString.stringify(filters, { arrayFormat: 'index' }).replaceAll('%5B', '[').replaceAll('%5D', ']');
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/recebimento-agend/?${qry}`, {
          timeout: 1000 * 50,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  getReceivingScheduleInvoices: (filters = {}) => {
    const qry = queryString.stringify(filters, { arrayFormat: 'index' }).replaceAll('%5B', '[').replaceAll('%5D', ']');
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/recebimento-agend-nota/?${qry}`, {
          timeout: 1000 * 50,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  getReceivingScheduleInvoiceProducts: (filters = {}) => {
    const qry = queryString.stringify(filters, { arrayFormat: 'index' }).replaceAll('%5B', '[').replaceAll('%5D', ']');
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/recebimento-agend-nota-prod/?${qry}`, {
          timeout: 1000 * 50,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  setReceivingSchedule: (body) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .post(`/v1/recebimento-agend/`, body, {
          headers: { 'Content-Type': 'application/json' },
          timeout: 1000 * 60,
        })
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  postNewReceivingSchedule: (body) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .post(`/v1/recebimento-agend/newCreateSchedule`, body, {
          headers: { 'Content-Type': 'application/json' },
          timeout: 1000 * 60,
        })
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  putReceivingSchedule: (body) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .put(`/v1/recebimento-agend/`, body, {
          headers: { 'Content-Type': 'application/json' },
          timeout: 1000 * 60,
        })
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  setReceivingScheduleInvoice: (body) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .post(`/v1/recebimento-agend-nota/`, body, {
          headers: { 'Content-Type': 'application/json' },
          timeout: 1000 * 60,
        })
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  setReceivingScheduleInvoiceProduct: (body) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .post(`/v1/recebimento-agend-nota-prod/`, body, {
          headers: { 'Content-Type': 'application/json' },
          timeout: 1000 * 60,
        })
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  cancelReceivingSchedule: (codigo) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .patch(`/v1/recebimento-agend/${codigo}/cancelar`, {
          timeout: 1000 * 15,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  finishReceivingSchedule: (codigo) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .patch(`/v1/recebimento-agend/${codigo}/finalizar`, {
          timeout: 1000 * 15,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  deleteReceivingScheduleInvoice: (codigo) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .delete(`/v1/recebimento-agend-nota/${codigo}`, {
          timeout: 1000 * 15,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  deleteReceivingScheduleInvoiceProduct: (codigo) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .delete(`/v1/recebimento-agend-nota-prod/${codigo}`, {
          timeout: 1000 * 15,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  uploadXMlFiles: (formData) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .post('/v1/recebimento-agend-nota/uploadxml', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          timeout: 1000 * 60,
        })
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  setReceivingScheduleByXml: (body) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .post(`/v1/recebimento-agend/xml`, body, {
          headers: { 'Content-Type': 'application/json' },
          timeout: 1000 * 60,
        })
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  getCompanyData: (cnpj) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/recebimento/consulta-cnpj/${cnpj.replace(/\D/g, '')}`, {
          headers: { 'Content-Type': 'application/json' },
          timeout: 1000 * 60,
        })
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  },
};
